import { PayloadAction } from "@reduxjs/toolkit";
import { ContractFunnel } from "features/subscription-process/pricing-process/types/interfaces";
import { PricingState } from "../pricingSlice";

export const shoppingCartReducers = {
  addShoppingCartItem: (state: PricingState, action: PayloadAction<ContractFunnel>) => {
    // Initialise le panier s'il n'existe pas
    if (!state.shoppingCart) {
      state.shoppingCart = [];
    }
    // Ajoute l'item au panier
    state.shoppingCart.push(action.payload);
  },

  removeShoppingCartItem: (state: PricingState, action: PayloadAction<string>) => {
    // Vérifie que le panier existe avant de filtrer
    if (state.shoppingCart) {
      state.shoppingCart = state.shoppingCart.filter(
        contract => contract.hash !== action.payload
      );
    }
  },
  resetShoppingCart: (state: PricingState) => {
    state.shoppingCart = [];
  },
}
